export type CaptureMode = 'system' | 'tab';

declare global {
  interface Window {
    desktopBridge?: {
      isDesktop: boolean;
      platform: string;
      openTabMode: () => Promise<boolean>;
    };
  }
}

export function isDesktopRuntime(): boolean {
  return typeof window !== 'undefined' && Boolean(window.desktopBridge?.isDesktop);
}

export async function openDesktopTabMode(): Promise<boolean> {
  if (!window.desktopBridge?.isDesktop) return false;
  await window.desktopBridge.openTabMode();
  return true;
}

export type CaptureOptions = DisplayMediaStreamOptions & {
  preferCurrentTab?: boolean;
  selfBrowserSurface?: 'include' | 'exclude';
  surfaceSwitching?: 'include' | 'exclude';
};

export function isRetryableDisplayMediaError(error: unknown): boolean {
  return error instanceof DOMException && ['TypeError', 'OverconstrainedError', 'NotSupportedError'].includes(error.name);
}

export function buildCaptureOptions(_mode: CaptureMode): CaptureOptions {
  return {
    video: true,
    audio: true,
    preferCurrentTab: false,
    selfBrowserSurface: 'exclude',
    surfaceSwitching: 'exclude'
  };
}
